const scrollBarWidth = (() => {
  // Create a test element with scrolling content
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll";
  outer.style.width = "100px";
  outer.style.position = "absolute";
  outer.style.top = "-9999px";

  try {
    document.body.appendChild(outer);

    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    // If scrollbar overlays content, clientWidth will equal offsetWidth
    // If scrollbar takes up space, clientWidth will be less than offsetWidth
    return outer.offsetWidth - outer.clientWidth;
  } finally {
    document.body.removeChild(outer);
  }
})();

export default scrollBarWidth;
